import { NotificationConfig } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getNotificationTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as NotificationConfig;

	return [
		{
			id: 'add-channel',
			selector: '[data-tour="add-channel"]',
			content:
				'Once the channel type has been selected from the dropdown options on the button, that channel will be added to the task configuration.',
		},
		...(config.channels.length > 0
			? [
					{
						id: 'channel',
						selector: '[data-tour="channel"]',
						content: 'The notification channel and all its configurables.',
					},
					{
						id: 'enabled',
						selector: '[data-tour="enabled"]',
						content:
							'Required: When unchecked, the task will ignore the channel during execution time, and will therefore not send out any notifications for that channel.',
					},
					{
						id: 'delete-channel',
						selector: '[data-tour="delete-channel"]',
						content: 'Removes the selected channel from the advanced view.',
					},
					{
						id: 'channel-type',
						selector: '[data-tour="channel-type"]',
						content: 'The channel type (for example, email) of the current channel.',
					},
					{
						id: 'channel-name',
						selector: '[data-tour="channel-name"]',
						content:
							"Required: This is the channel's name, used to distinguish channels of the same types.",
					},
					{
						id: 'delivery-type',
						selector: '[data-tour="delivery-type"]',
						content: 'Required: Determines how many notifications should be sent for each channel.',
					},
					{
						id: 'channel-properties',
						selector: '[data-tour="channel-properties"]',
						content: 'Required: These properties are specific to the type of channel.',
					},
					{
						id: 'to-email',
						selector: '[data-tour="to-email"]',
						content:
							'Required: The receiver email addresses. Note that the emails can be separated by either commas or semicolons. The email will be sent to each address separately.',
					},
					{
						id: 'email-subject',
						selector: '[data-tour="email-subject"]',
						content: 'Required: The subject of the email.',
					},
					{
						id: 'email-message',
						selector: '[data-tour="email-message"]',
						content:
							'Optional: The body of the email. It is only optional if there is an existing email template on the channel.',
					},
					{
						id: 'create-email-template',
						selector: '[data-tour="create-email-template"]',
						content:
							'Optional: Add a HTML templated email to the notification, this template can be customized in the editor after clicking on the button.',
					},
				]
			: []),
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
